import { render } from "./PageIntroduction.vue?vue&type=template&id=7abe4ab1"
import script from "./PageIntroduction.vue?vue&type=script&lang=js"
export * from "./PageIntroduction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__